import * as React from "react";
import { ToastContainer } from "react-toastify";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiMusic, FiShield, FiUser } from "react-icons/fi";

import { Navigator } from "./Navigator";
import styles from "./styles.module.scss";

type CustomNavigationProps = {
  name?: string;
  user?: any;
  page?: string;
  isOpen?: boolean;
  onClose?: () => void;
};

const CustomNavigation = ({
  name,
  user,
  page,
  isOpen,
  onClose,
}: CustomNavigationProps) => {
  const [internalOpen, setInternalOpen] = React.useState(false);

  const isControlled = typeof isOpen === "boolean";
  const navigationOpen = isControlled ? Boolean(isOpen) : internalOpen;

  const displayName =
    user?.fullname ||
    user?.fullName ||
    user?.name ||
    user?.email ||
    "Admin User";

  const role =
    user?.role || user?.userRole || user?.roles?.[0] || page || "Admin";

  const closeNavigation = React.useCallback(() => {
    if (onClose) {
      onClose();
      return;
    }

    setInternalOpen(false);
  }, [onClose]);

  const toggleNavigation = () => {
    if (isControlled) {
      if (navigationOpen) {
        onClose?.();
      }
      return;
    }

    setInternalOpen((prev) => !prev);
  };

  React.useEffect(() => {
    if (!navigationOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [navigationOpen]);

  return (
    <>
      <ToastContainer />

      {!isControlled && (
        <button
          type="button"
          className={styles.mobileToggle}
          onClick={toggleNavigation}
          aria-label={
            navigationOpen ? "Close navigation menu" : "Open navigation menu"
          }
        >
          {navigationOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}

      {navigationOpen && (
        <button
          type="button"
          className={styles.backdrop}
          onClick={closeNavigation}
          aria-label="Close navigation"
        />
      )}

      <aside
        className={`${styles.navigation} ${
          navigationOpen ? styles.mobileNavigation : ""
        }`}
      >
        <div className={styles.sidebarGlow} />

        <div className={styles.brandArea}>
          <div className={styles.brandLogo} aria-label="Upcoma Entertainment">
            <div className={styles.logoText}>
              <span className={styles.logoOrange}>Up</span>
              <span className={styles.logoWhite}>coma</span>
            </div>
            <span className={styles.logoSubText}>Entertainment</span>
          </div>

          <button
            type="button"
            className={styles.navCloseButton}
            onClick={closeNavigation}
            aria-label="Close navigation menu"
          >
            <FaTimes />
          </button>
        </div>

        <div className={styles.portalBadge}>
          <FiShield />
          <span>Admin Control Center</span>
        </div>

        <div className={styles.userCard}>
          <div className={styles.userAvatar}>
            <FiUser />
          </div>

          <div className={styles.userInfo}>
            <strong>{displayName}</strong>
            <span>{role}</span>
          </div>
        </div>

        <Navigator
          name={name}
          page={page}
          user={user}
          onNavigate={closeNavigation}
        />

        <div className={styles.sidebarFooter}>
          <div className={styles.footerIcon}>
            <FiMusic />
          </div>

          <div>
            <strong>Upcoma Suite</strong>
            <span>Music platform operations</span>
          </div>
        </div>
      </aside>
    </>
  );
};

export default CustomNavigation;
